<template>
  <v-content>
    <v-row justify="center">
      <v-dialog v-model="dialogItens" max-width="720">
        <v-card>
          <v-card-title>
            <v-row style="max-width=590px;background-color:#CCC">
              <v-col class="pl-2" cols="6">
                <p class>
                  ITENS PEDIDOS -
                  <span class="pl-1">{{ itemPedidoSel }}</span>
                </p>
              </v-col>
              <v-col class="pl-2 pt-2 pb-2" cols="6">
                <div style="text-align: right">
                  <v-btn
                    @click="imprimir(itemSel)"
                    depressed
                    color="print"
                    fab
                    x-small
                    dark
                  >
                    <i class="material-icons">local_print_shop</i>
                  </v-btn>
                  <v-btn
                    @click="dialogItens = false"
                    depressed
                    color="primary"
                    fab
                    x-small
                    dark
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-title>

          <v-row class="ml-2 text-left">
            <v-col cols="4">Cliente: {{ itemSel.nome }}</v-col>
            <v-col cols="4">Tel: {{ itemSel.telefone }}</v-col>
          </v-row>
          <v-row v-if="itemSel.retirar_local == 0" class="ml-2 text-left">
            <v-col cols="6">Endereço: {{ endereco_entrega.logradouro }}</v-col>
            <v-col cols="2">Nº: {{ endereco_entrega.numero }}</v-col>
            <v-col col="2">Cep: {{ endereco_entrega.cep }}</v-col>
            <v-col cols="6">Bairross: {{ endereco_entrega.bairro }}</v-col>
          </v-row>
          <v-row class="ml-2 text-left">
            <v-col cols="6">Forma Pagamento: {{ itemSel.forma_pagto }}</v-col>
          </v-row>
          <v-row v-if="itemSel.retirar_local == 1" class="ml-2 text-left">
            <v-col cols="6">Retirar no local</v-col>
          </v-row>

          <v-simple-table
            style="margin: 15px !important"
            dense
            :fixed-header="fixedHeader"
            :height="heightTable"
          >
            <template v-slot:default>
              <thead>
                <th>Produto</th>
                <th>Qtde.</th>
                <th>Obs.</th>
              </thead>
              <tbody>
                <tr v-for="item in itensDetalhe" :key="item.nome">
                  <td style="text-align: left">
                    {{ item.codigo }} - {{ item.descricao }}
                  </td>
                  <td>{{ item.qtde }}</td>
                  <td>{{ item.obs }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-flex class="pb-2 ml-0">
          <v-alert dense color="primary" class="text-left" text border="left"
            >PEDIDOS</v-alert
          >
        </v-flex>
      </v-col>
      <v-col cols="5" md="3" lg="3">
        <v-menu
          ref="menu"
          :close-on-content-click="false"
          v-model="menu"
          :nudge-right="140"
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateIniFormatted"
              label="Data Inicial"
              readonly
              v-on="on"
              filled
              dense
              clearable
              hide-details
              color="info"
              header-color="primary"
              prepend-inner-icon="date_range"
              @blur="date_ini = parseDate(dateIniFormatted)"
            ></v-text-field>
          </template>
          <v-date-picker
            no-title
            scrollable
            locale="pt-br"
            v-model="date_ini"
            @input="menu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="5" md="3" lg="3">
        <v-menu
          ref="menu2"
          :close-on-content-click="false"
          v-model="menu2"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              slot="activator"
              v-model="dateFimFormatted"
              label="Data Final"
              color="info"
              header-color="primary"
              persistent-hint
              filled
              hide-details
              dense
              v-on="on"
              clearable
              prepend-inner-icon="event"
              @blur="date_fim = parseDate(dateFimFormatted)"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="pt-br"
            v-model="date_fim"
            no-title
            @input="menu2 = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col class="mb-5" cols="4" md="3" lg="3">
        <v-select
          :items="dropdown_icon"
          v-model="statusSel"
          label="Selecione um status"
          filled=""
          dense=""
          item-text="text"
          item-value="state"
          @change="filtrar"
        ></v-select>
      </v-col>
    </v-row>

    <v-card v-show="!sv">
      <v-row no-gutters>
        <v-col cols="4" md="3" lg="3">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Pesquisar"
            filled
            dense
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="mb-5" cols="4" md="3" lg="3">
          <v-btn color="success" @click="buscaPedidos()" class="mr-4">
            <v-icon>filter_list</v-icon>Filtrar
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="itemsProdutos"
        :loading="loading_table"
        :items-per-page="25"
        loading-text="Carregando... Aguarde"
        dense
        :search="search"
        :footerProps="footerProps"
        no-data-text="Nenhum resultado encontrado!"
        no-results-text="Nenhum resultado encontrado!"
        class="elevation-1"
      >
        <template slot:item.action="{ item }">
          <v-icon
            color="btBlue"
            class="mr-2"
            @click="ver_detalhe(item, item.id, item.itens)"
            >find_in_page</v-icon
          >
        </template>
      </v-data-table>
    </v-card>

    <v-snackbar
      :timeout="tempo"
      :color="error"
      :multi-line="multiline"
      :vertical="mode === 'vertical'"
      v-model="snackbar"
    >
      {{ textSnack }}
      <v-btn @click.native="snackbar = false">Fechar</v-btn>
    </v-snackbar>

    <v-snackbar
      :timeout="5000"
      :color="sucesso"
      :top="true"
      :multi-line="'multi-line'"
      :vertical="'vertical'"
      v-model="snackbarSuccess"
    >
      {{ textSucesso }}
      <v-btn flat @click.native="snackbarSuccess = false">Fechar</v-btn>
    </v-snackbar>

    <iframe style="display:none" id="textfile"></iframe>
  </v-content>
</template>

<script>
var moment = require("moment");
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  props: {
    source: String,
  },
  data: (vm) => ({
    heightTable: 550,
    fixedHeader: true,
    itemPedidoSel: "",
    itensDetalhe: [],
    dialogItens: false,
    itemSel: [],
    endereco_entrega: "",
    forma_pagto: "",
    dropdown_icon: [
      { text: "Todos", state: "T" },
      { text: "Recebido", state: "1" },
      { text: "Preparando", state: "2" },
      { text: "Preparo Concluído", state: "3" },
      { text: "Embalando", state: "4" },
      { text: "Saiu Entrega", state: "5" },
      { text: "Entregue Concluído", state: "6" },
      { text: "Concluído", state: "7" },
    ],

    date_fim: new Date().toISOString().substr(0, 10),
    date_ini: moment().format("YYYY-MM-01"),
    dateFimFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    dateIniFormatted: moment().format("01/MM/YYYY"),
    menu: false,
    menu2: false,
    footerProps: { "items-per-page-options": [30, 50, 100] },
    cadastro: true,

    error: "error",
    tempo: 5000,
    mode: "vertical",

    sucesso: "botao_sucesso",
    snackbarSuccess: false,
    snackbar: false,
    textSucesso: "",
    textSnack: "",
    multiline: true,

    singleLine: true,
    produto: {
      id: "",
      descricao: "",
      codigo: "",
      preco: "",
      id_categoria: "",
      descricao_reduzida: "",
      qtde_sistema: "",
      unidade: "UN",
      img: "",
    },
    itemsCategoria: [],
    itemsUnidade: ["UN"],

    filtroProduto: "Produtos ",
    sv: false,
    dialogCadastro: false,
    dialogCadastroEditar: false,
    itensPorPagina: 25,
    itemsProdutos: [],
    itemsProdutosSgt: [],
    itemsProdutosSgtVinculados: [],
    search: "",
    searchVinculados: "",
    loading_table: false,
    selProduto: "",
    itemEdit: "",
    valid: false,
    dialogVinc: false,
    statusSel: "T",
    headers: [
      {
        text: "Código",
        align: "right",
        value: "id",
      },
      {
        text: "Data",
        value: "data",
        sortable: true,
        align: "left",
      },
      {
        text: "Status",
        value: "status",
        sortable: true,
        align: "left",
      },
      {
        text: "Cliente",
        value: "nome",
        align: "left",
      },
      {
        text: "Previsão Entrega",
        value: "previsao_entrega",
        align: "right",
      },
      {
        text: "Valor",
        value: "valor_total_pedido",
        align: "right",
      },
      { text: "Detalhes", value: "action", sortable: false },
    ],
  }),
  watch: {
    date_ini(val) {
      this.dateIniFormatted = this.formatDate(this.date_ini);
    },
    date_fim(val) {
      this.dateFimFormatted = this.formatDate(this.date_fim);
    },
  },
  mounted() {
    //this.buscaProdutos();
    this.buscaPedidos();
  },
  methods: {
    imprimir(item) {
      this.loading_baixar = true;

      axios
        .post(`/pedido/imprimir`, {
          pedido: item,
        })
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
            alert("erro");
          } else {
            this.loading_baixar = false;
            // document.getElementById("linkDownload").innerHTML = response.data;

            var textfile;

            let iframe;

            iframe = document.getElementById("textfile");
            iframe.setAttribute("src", "");
            // iframe.setAttribute("src", response.data.url);
            iframe.setAttribute("src", response.data.url);

            //  printJS("http://localhost:8080/Delivery.pdf");
            setTimeout(() => {
              iframe.focus();
              iframe.contentWindow.print();
              // printJS("pedido-0211.txt");
              //this.$htmlToPaper("linkDownload");
              //  document.getElementById("linkDownload").href = response.data.url;
              //document.getElementById("linkDownload").download =
              // '"http://192.168.1.135:75/GKFq70ibiI38urfHml.pdf"';
              // document.getElementById("linkDownload").click();
            }, 1000);
          }
        });
    },
    ver_detalhe(item, id_pedido, itens) {
      this.itemPedidoSel = id_pedido;
      this.itensDetalhe = itens;
      this.itemSel = item;
      this.endereco_entrega = item.endereco_entrega;
      this.forma_pagto = item.forma_pagto;
      this.dialogItens = true;
    },
    filtrar(val) {
      this.statusSel = val;
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    buscaPedidos() {
      this.loading_table = true;
      axios
        .post(`/pedido/all`, {
          status: this.statusSel,
          data_ini: this.date_ini,
          data_fim: this.date_fim,
        })
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.loading_table = false;
            //this.loading_filtrar = false;
            this.itemsProdutos = response.data;
          }
        });
    },
  },
};
</script>
<style scoped>
.v-input--selection-controls {
  padding: 5px !important;
  margin-bottom: 5px !important;
  margin-top: 16px;
  padding-top: 4px;
}
.v-data-table td {
  font-size: 0.685rem !important;
}
.v-overflow-btn {
  margin-top: 0px !important;
  padding-top: 0;
}
</style>
